import { PopupIds } from '../constants/PopupIds';
import '../vendor/jquery.scrollbar-0.2.10';
import { isEmptyValue, isValidEmail } from '../general/modules/validators';
import { Localization } from '../localization/localization';
import { sendSupportTicket } from './sendSupportTicket';
import { Url } from '../general/modules/url';
import { SupportTicketRequestData } from './support-ticket-request-data';
import { CurrentUser } from '../general/modules/user/currentUser';
import { container } from '../utils/container/container';
import { FeatureFlagsLoader } from '../utils/feature-flags/feature-flags-loader';
import { ServiceIds } from '../utils/container/service-ids';
import { FlagNames } from '../utils/feature-flags/flag-names';
import { initUnreadMessagesBadge, showTheymesWidget, widgetTheymesIsOn } from './supportWidgetTheymes';

let ticketInProgress = false;

enum WebChatDataTypes {
    SINGLELINE = 'singleline',
    MULTILINE = 'multiline',
    NUMBER = 'number',
    CHECKBOX = 'checkbox',
    DROPDOWN = 'dropdown',
    DATA = 'date'
}

export enum WebChatMinimizedIcon {
    SHOW = 'show',
    HIDE = 'hide'
}

function onOpenSupportButtonClick() {
    window.app.game_popup_close();
    window.app.game_popup(PopupIds.SUPPORT_TICKET);
}

function onCloseSupportSuccessButtonClick() {
    window.app.game_popup_close();
}

function onCloseSupportButtonClick() {
    const $supportTicket = $('#support_ticket');
    window.app.game_popup_close();

    $('.support_ticket_error', $supportTicket).hide();
}

function onCustomSelectClick() {
    const $supportTicket = $('#support_ticket');
    const customOptions = $supportTicket.find('.options');

    if (customOptions.attr('data-expanded') === 'false') {
        customOptions.slideDown(function slide() {
            customOptions.attr('data-expanded', 'true');
        });
    } else {
        customOptions.slideUp(function slide() {
            customOptions.attr('data-expanded', 'false');
        });
    }
}

function personalDataToggle(personalDataShow = false) {
    const $supportTicket = $('#support_ticket');
    const formElements = $supportTicket.find('form .textarea, form .input:not(:first-child), form > button');
    const personalDataFormElement = $supportTicket.find('.deleted_personal_data');
    if (personalDataShow === true) {
        formElements.hide();
        personalDataFormElement.show();
    } else {
        formElements.show();
        personalDataFormElement.hide();
    }
}

function onCustomSelectOptionClick(e: JQuery.Event) {
    const $supportTicket = $('#support_ticket');
    e.stopPropagation();
    const optionValue = $(this).data('value');
    personalDataToggle(optionValue === 'personal_data');
    $supportTicket.find('select option').text(optionValue);
    $supportTicket.find('.chosen').text($(this).text());
    $supportTicket.find('.options').slideUp(function slide() {
        $supportTicket.find('.options')
            .attr(
                'data-expanded',
                'false'
            );
    });
}

function getSupportRequestData() {
    const $supportTicket = $('#support_ticket');

    const user = window.app.user;

    const subject = $('#support_ticket_subject').val();
    if (subject === undefined) {
        throw new Error('Support ticket subject is undefined');
    }
    const body = $('#support_ticket_body').val();
    if (body === undefined) {
        throw new Error('Support ticket body is undefined');
    }
    const email = $('#support_ticket_email').val();
    if (email === undefined) {
        throw new Error('Support ticket email is undefined');
    }

    const supportData: SupportTicketRequestData = {
        subject: subject,
        body: body,
        type: $('#support_ticket_type', $supportTicket).text(),
        email: email,
        browser: window.app.config.user_browser,
        // eslint-disable-next-line id-length
        ua: window.app.config.user_agent,
        hasPayment: user.hasPayment,
        nickname: user.gameNickname,
        donateAmount: user.donate,
        paymentCohort: user.paymentCohort,
        language: window.app.config.language,
        uid: '',
        network: window?.app?.config?.current_entry_point ?? 'N/A',
        realm: window.app.config.user_realm,
        suid: CurrentUser.getInstance().getSuid()
    };
    if (window?.app?.config?.user_auth_token) {
        supportData.token = window.app.config.user_auth_token;
    }

    return supportData;
}

function validateSupportForm() {
    const subject = $('#support_ticket_subject').val();
    if (isEmptyValue(subject as string)) {
        return Localization._n('support.emptySubject');
    }

    const body = $('#support_ticket_body').val();
    if (isEmptyValue(body as string)) {
        return Localization._n('support.emptyBody');
    }

    const type = $('#support_ticket_type').val();
    if (isEmptyValue(type as string)) {
        return Localization._n('support.emptyType');
    }

    const email = $('#support_ticket_email').val();
    if (isEmptyValue(email as string)) {
        return Localization._n('support.emptyEmail');
    }

    if (!isValidEmail(email as string)) {
        return Localization._n('support.wrongEmail');
    }

    return true;
}

function onSupportFormSubmit(event: JQuery.SubmitEvent) {
    const $supportTicket = $('#support_ticket');

    event.preventDefault();

    if (ticketInProgress) {
        return;
    }

    const error = $supportTicket.find('.support_ticket_error');
    const formErrors = validateSupportForm();
    if (typeof formErrors === 'string') {
        error.text(formErrors).show();
        return;
    }

    ticketInProgress = true;

    let supportTicketData: SupportTicketRequestData;
    try {
        supportTicketData = getSupportRequestData();
    } catch (error) {
        error.text(Localization._n('support.common')).show();
        ticketInProgress = false;
        return;
    }
    sendSupportTicket(supportTicketData).then((result) => {
        if (result === true) {
            error.hide();
            $supportTicket.find('input').val('');
            $supportTicket.find('textarea').val('');
            window.app.game_popup_close();
            window.app.game_popup(PopupIds.SUPPORT_SUCCESS);
        } else {
            error.text(Localization._n('support.common')).show();
        }
        ticketInProgress = false;
    })
        .finally(() => {
            ticketInProgress = false;
        });
}

function onAnywhereClickWhileCustomSelectOpened() {
    const $supportTicket = $('#support_ticket');

    const customOptions = $supportTicket.find('.options');
    if (customOptions.attr('data-expanded') === 'true') {
        customOptions.slideUp(function slide() {
            customOptions.attr('data-expanded', 'false');
        });
    }
}

function openDeletePersonalDataWindow() {
    window.location.href = Url.getGdprUrl();
}

function showHelpShiftWidget(event: JQuery.Event) {
    event.preventDefault();
    if (!window.helpshiftWidgetConfig.userId) {
        initWebChat();
    }
    const helpshiftLib = window.HelpshiftWidget;
    helpshiftLib('open');
}

export function initWebChat() {
    if (widgetTheymesIsOn()) {
        return;
    }
    const ffLoader = container.get<FeatureFlagsLoader>(ServiceIds.FEATURE_FLAG_LOADER);
    const webChat = ffLoader.get(FlagNames.WEB_CHAT_SUPPORT);
    if (webChat.isOn()) {
        const helpshiftLib = window.HelpshiftWidget;
        const suid = CurrentUser.getInstance().getSuid()
            .toString();
        window.helpshiftWidgetConfig.userId = suid;
        window.helpshiftWidgetConfig.userEmail = window.app.user.email;
        window.helpshiftWidgetConfig.cifs = getChatCustomFieldsConfig();
        helpshiftLib('updateHelpshiftWidgetConfig');
    }
}

function getChatCustomFieldsConfig() {
    return {
        account_id: {
            type: WebChatDataTypes.SINGLELINE,
            value: CurrentUser.getInstance().getAccountId()
                .toString()
        },
        suid: {
            type: WebChatDataTypes.SINGLELINE,
            value: CurrentUser.getInstance().getSuid()
                .toString()
        },
        donate_amount: {
            type: WebChatDataTypes.NUMBER,
            value: window.app.user.donate
        },
        payment_cohort: {
            type: WebChatDataTypes.NUMBER,
            value: window.app.user.paymentCohort
        },
        language: {
            type: WebChatDataTypes.SINGLELINE,
            value: window.app.config.language
        },
        realm: {
            type: WebChatDataTypes.NUMBER,
            value: window.app.config.user_realm
        },
        account_email: {
            type: WebChatDataTypes.SINGLELINE,
            value: CurrentUser.getInstance().getEmail()
        },
        suid_by_email: {
            type: WebChatDataTypes.SINGLELINE,
            value: CurrentUser.getInstance().getSuid()
                .toString()
        }
    };
}

export function showMinimizedSupportChat() {
    const chatBlock = $('#minimized_chat');
    const messageCount = parseInt($('#minimized_chat #unread_chat_messages_count').text());
    if (messageCount > 0) {
        chatBlock.show();
    }
}

function initSupportChatWindow() {
    if (widgetTheymesIsOn()) {
        $('#support_button').on('click', showTheymesWidget);
    } else {
        $('#support_button').on('click', showHelpShiftWidget);
    }
}

function initSupportTicketWindow() {
    const $supportTicket = $('#support_ticket');
    $('#support_button').on('click', onOpenSupportButtonClick);
    $('#support_success .js-close-button,#support_success .support_but').on('click', onCloseSupportSuccessButtonClick);

    // @ts-ignore
    $('#support_ticket_body.scrollbar-rail').scrollbar();
    $supportTicket.find('.js-close-button').on('click', onCloseSupportButtonClick);
    $(document).on('click', onAnywhereClickWhileCustomSelectOpened);
    $supportTicket.find('.select').on('click', onCustomSelectClick);
    $supportTicket.find('.option').on('click', onCustomSelectOptionClick);
    $supportTicket.find('form').on('submit', onSupportFormSubmit);
    // @ts-ignore
    $supportTicket.find('.support_appeal').on('click', personalDataToggle);
    $supportTicket.find('.support_deleted_personal_data').on('click', openDeletePersonalDataWindow);
}

export function startupSupportModule() {
    const ffLoader = container.get<FeatureFlagsLoader>(ServiceIds.FEATURE_FLAG_LOADER);
    const webChat = ffLoader.get(FlagNames.WEB_CHAT_SUPPORT);

    if (webChat.isOn()) {
        initSupportChatWindow();
    } else {
        // TODO https://youtrack.scorewarrior.dev/issue/P3-36956/Site-Vypilit-staroe-okno-sapporta
        initSupportTicketWindow();
    }
}

window.SupportChat = {
    initBadge: initUnreadMessagesBadge
};
